import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-label font-semibold text-accent-700 bg-accent-100/80 rounded-full mb-3">
            Browse Categories
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Explore VigorBuy Spreadsheet Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Browse through our organized product categories — each one links directly to the latest collections on VigorBuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/50 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline overflow-hidden"
            >
              <div className="relative h-28 md:h-32 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} category on VigorBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/80 via-transparent to-transparent" />
              </div>
              <div className="flex items-center gap-2 px-3 py-2.5">
                <div className="w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-md bg-background-50 group-hover:bg-primary-100/50 transition-colors">
                  <i className={`${cat.icon} text-sm text-primary-500`}></i>
                </div>
                <span className="text-xs font-label font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}